/* Single image */
import Fimg1 from '../images/icon/1.png'
import Fimg2 from '../images/icon/2.png'
import Fimg3 from '../images/icon/3.png'

const Features = [
    {
        id: 1,
        Fimage: Fimg1,
        title: 'Free Delivery',
        description: '.',
    },
    {
        id: 2,
        Fimage: Fimg2,
        title: 'Support 24/7',
        description: '',
    },
    {
        id: 3,
        Fimage: Fimg3,
        title: 'Secure Payment',
        description: ''
    }
];

export default Features;